<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import Lenis from '@studio-freight/lenis'
import HeaderView from '@/components/HeaderView.vue'
import ProductsHeroSection from '@/components/ProductsHeroSection.vue'
import ProductsProblemSection from '@/components/ProductsProblemSection.vue'
import ProductsFeaturesSection from '@/components/ProductsFeaturesSection.vue'
import ProductsShowcaseSection from '@/components/ProductsShowcaseSection.vue'
import ProductsPricingSection from '@/components/ProductsPricingSection.vue'
import ProductsBenefitsSection from '@/components/ProductsBenefitsSection.vue'
import ProductsDemoSection from '@/components/ProductsDemoSection.vue'
import FooterView from '@/components/FooterView.vue'
import { useSEO } from '@/composables/useSEO'

const { updateMetaTags } = useSEO()

let lenis: Lenis | null = null

onMounted(() => {
  // Configurar SEO para la página de productos (transaccional)
  updateMetaTags({
    title: 'Fourintrack - Software CMMS/GMAO | Prueba Gratis 14 Días',
    description: 'Software CMMS/GMAO en la nube para gestión de activos y mantenimiento. Reduce paradas, costos y riesgos. Prueba gratis 14 días. Ideal para empresas en Colombia y LATAM.',
    keywords: 'software CMMS, GMAO, software mantenimiento preventivo, software órdenes de trabajo, gestión de activos, CMMS en la nube, software mantenimiento Colombia, sistema mantenimiento',
    url: 'https://fourin.co/products',
    canonical: 'https://fourin.co/products',
    type: 'website',
    organization: true
  })
  lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
  })
  function raf(time: number) {
    lenis?.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  // Restablecer scroll al inicio de la página
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

onBeforeUnmount(() => {
  if (lenis) {
    lenis.destroy()
  }
})
</script>

<template>
  <div>
    <HeaderView />
    <ProductsHeroSection />
    <ProductsProblemSection />
    <ProductsBenefitsSection />
    <!-- <ProductsFeaturesSection /> -->
    <ProductsShowcaseSection />
    <ProductsPricingSection />
    <ProductsDemoSection />
    <FooterView />
  </div>
</template>
